import Formatters from './Formatters';
import { PhoneCountryPrefixes } from '../globals/utilities/PhoneCountryPrefixes';

export default class Validators {
	static Required(i) {
		let result;
		if (Array.isArray(i)) {
			result = i.length > 0;
		} else {
			result = (i !== null && i !== undefined) ? String(i).trim() : '';
		}
		return !result ? 'To pole jest wymagane' : '';
	}

	static RequiredNip(i) {
		return this.Required(i.value) ? 'Prosimy wpisać poprawny numer NIP' : '';
	}

	static Email(input:string, options?:string) {
		const ignoreEmpty = options && options.indexOf('IgnoreEmpty') > -1;
		if (input === '' && ignoreEmpty) { return ''; }
		if (input.endsWith('@nop')) { return ''; }
		const filter = /^[\w%\+\-]+(\.[\w%\+\-]+)*@[\w%\+\-]+(\.[\w%\+\-]+)+$/;
		if (!filter.test(input)) return 'Prosimy o wpisanie prawidłowego adresu';
		return '';
	}

	static LoginCode(s) {
		if (s.length < 4 || s.length > 4) { return 'Kod aktywacyjny powinien składać się z 4 cyfr'; }
		return '';
	}

	static Www(i) {
		if (!i) { return ''; }
		return (!i.match(/^(http:\/\/www\.|https:\/\/www\.|http:\/\/|https:\/\/)?[a-z0-9]+([\-\.]{1}[a-z0-9]+)*\.[a-z]{2,5}(:[0-9]{1,5})?(\/.*)?$/gm)) ? 'Prosimy o wpisanie prawidłowego adresu' : '';
	}

	static Phone(i, s) {
		const ignoreEmpty = s && s.indexOf('IgnoreEmpty') > -1;
		const areaCodeRequired = s && s.indexOf('AreaCodeRequired') > -1;
		if (i === '' && ignoreEmpty) { return ''; }
		if (/[a-zA-Z]+/g.test(i)) { return 'Numer telefonu nie może zawierać liter'; }
		if (/[^0-9+\- ]/g.test(i) || i.indexOf('+') > 0) { return 'Numer zawiera niepoprawne znaki'; }
		i = i.replace(/[^0-9+]/g, '');
		if (areaCodeRequired && !/[+][0-9]{11,12}/g.test(i)) {
			return 'Numer musi zawierać kod kraju';
		}
		if (i.length > 15) { return 'Numer telefonu nie może być dłuższy niż 15 znaków'; }
		if (i.length < 9) { return 'Numer telefonu nie może być krótszy niż 9 znaków'; }
		return '';
	}

	static PhoneWithPrefix(i) {
		const p = PhoneCountryPrefixes.find((el) => i.startsWith(el.dial_code));
		i = i.replace(p?.dial_code, '');
		i = i.replace(/[^0-9+]/g, '');
		if (p?.dial_code === '+48') {
			if (i.length === 9) { return ''; }
			return 'Wpisz właściwy numer telefonu';
		}
		if (i.length > 15) { return 'Numer telefonu nie może być dłuższy niż 15 znaków'; }
		return '';
	}

	static IsMobilePhone(i) {
		const mobilePhoneArray = ['12', '13', '14', '15', '16', '17', '18', '22', '23', '24', '25', '29', '32', '33',
			'34', '41', '42', '43', '44', '46', '48', '52', '54', '55', '56', '58', '59', '61', '62', '63', '65',
			'67', '68', '71', '74', '75', '76', '77', '81', '82', '83', '84', '85', '86', '87', '89', '91', '94',
			'95'];

		if (this.Phone(i) === '') {
			let number = i;
			if (number.indexOf('+48') > -1) {
				number = number.replace('+48', '');
			}
			if (number.indexOf('+') > -1) {
				number = number.replace('+', '');
			}
			number = number.split('');
			if (number.length >= 9) {
				return !mobilePhoneArray.some((el) => number[0] + number[1] === el);
			}
			return false;
		}
		return false;
	}

	static PureNip(i) {
		let nip = String(i);
		nip = nip.replace(/[\ \-]/gi, '');
		if (nip === '0000000000') { return 'Prosimy wpisać poprawny numer NIP'; }
		const weight = [6, 5, 7, 2, 3, 4, 5, 6, 7];
		let sum = 0;
		const controlNumber = parseInt(nip.substring(9, 10), 10);
		for (let n = 0; n < weight.length; n++) {
			sum += (parseInt(nip.substring(n, n + 1), 10) * weight[n]);
		}
		return sum % 11 === controlNumber ? '' : 'Prosimy wpisać poprawny numer NIP';
	}

	static Nip(i) {
		function isValidNip(nip) {
			nip = nip.replace(/[\ \-]/gi, '');
			if (nip === '0000000000') { return 'Prosimy wpisać poprawny numer NIP'; }
			const weight = [6, 5, 7, 2, 3, 4, 5, 6, 7];
			let sum = 0;
			const controlNumber = parseInt(nip.substring(9, 10), 10);
			for (let n = 0; n < weight.length; n++) {
				sum += (parseInt(nip.substring(n, n + 1), 10) * weight[n]);
			}
			return sum % 11 === controlNumber;
		}
		i.value = String(i.value) || '';
		i.value = i.value.replace(/[\ \-]/gi, '');
		if (!i.value.length || i.country !== 'PL') { return ''; }
		return (i.value.length !== 10 || !isValidNip(i.value)) ? 'Prosimy wpisać poprawny numer NIP' : '';
	}

	static Currency() {}

	static Password(i) {
		if (i.length < 8) { return 'Hasło powinno składać się z przynajmniej 8 znaków.'; }
		if (i.length > 64) { return 'Hasło nie może być dłuższe niż 64 znaki.'; }
		return '';
	}

	static NoPhone(s:string) {
		const toValidate = (s || '').toLowerCase();
		if (/www.|https*:\/\//.test(toValidate)) {
			return 'To pole nie może zawierać adresu strony internetowej';
		}
		if (/\d{3}.{0,3}\d{3}.{0,3}\d{3}/.test(toValidate)) {
			return 'To pole nie może zawierać numeru telefonu. <a class="f-bold" href="/konto/profil/dane-kontaktowe">Wpisz go w Danych kontaktowych.</a>';
		}
		return '';
	}

	static Match(current, compare, form) {
		compare = form.Form.find((f) => f.Name === compare[0]);
		if (!compare || compare.Value === current) { return ''; }
		return 'Powtórzone hasło różni się od wprowadzonego powyżej';
	}

	static Number(i, s) {
		if (s === 'float') {
			return (!/^[0-9]+([,.][0-9]+)?$/.test(i)) ? 'Prosimy o wpisanie liczby' : '';
		}
		return (!Number.isInteger(Number(i))) ? 'Prosimy wpisać liczbę całkowitą' : '';
	}

	static MinMax(i, s) {
		const isModal = (s[2] === 'modal') ? ' #' : '';
		if (i && s) {
			i = Number(i);
			s[0] = Number(s[0]);
			s[1] = Number(s[1]);

			if (((s[0] || s[0] === 0) && s[1]) && (i < s[0] || i > s[1])) {
				return `Prosimy o wprowadzenie liczby z przedziału od ${Number(s[0])} do ${Number(s[1])}${isModal ? ' #' : ''}`;
			}
			if ((s[0] || s[0] === 0) && i < s[0]) {
				return `Prosimy o wprowadzenie liczby większej lub równej od ${Number(s[0]) - 1}${isModal ? ' #' : ''}`;
			}
			if (s[1] && i > s[1]) {
				return `Prosimy o wprowadzenie liczby mniejszej lub równej od ${Number(s[1]) + 1}${isModal ? ' #' : ''}`;
			}
		}
		return '';
	}

	static Range(i, s) {
		if (i && s) {
			const isModal = (s[2] === 'modal') ? ' #' : '';
			const len = String(i).length;
			const chars = ['znak', 'znaki', 'znaków'];

			s[0] = Number(s[0]); s[1] = Number(s[1]);
			if (s[1] && s[0] > s[1]) { s[0] = s[1]; } // BUG w formularzach!

			if (s[0] === s[1] && len === s[0]) {
				return '';
			}
			let msg = '';
			if (s[0] && len <= s[0]) {
				const diff = s[0] - len + 1;
				if (isModal) {
					msg = `Wprowadzony tekst # jest za krótki o ${Formatters.PluralForm(diff, chars, true)}`;
					msg += ` Minimalna ilość znaków to ${s[0]}`;
				} else {
					msg = `Podana wartość jest za krótka o ${Formatters.PluralForm(diff, chars, true)}`;
				}
			}
			if (s[1] && len > s[1]) {
				const diff = len - s[1];
				if (isModal) {
					msg = `Wprowadzony tekst # jest za długi o ${Formatters.PluralForm(diff, chars, true)}`;
					msg += ` Minimalna ilość znaków to ${s[0]}`;
				} else {
					msg = `Podana wartość jest za długa o ${Formatters.PluralForm(diff, chars, true)}`;
				}
			}
			return msg;
		}
		return '';
	}

	static Alphanumeric(i: string) {
		return (!/^[a-zA-Z0-9]+$/.test(i)) ? 'Prosimy o wpisanie tylko liter i cyfr (bez polskich znaków)' : '';
	}

	static RangeModal(i:string, s:[]) {
		if (i && s) {
			const isModal = (s[2] === 'modal') ? ' #' : '';
			const len = String(i).length;
			const chars = ['znak', 'znaki', 'znaków'];

			if (s[0] === s[1] && len === s[0]) {
				return '';
			}
			let msg = '';
			if (s[0] && len < s[0]) {
				const diff = s[0] - len;
				msg = `Tekst jest za krótki o ${Formatters.PluralForm(diff, chars, true)}`;
				if (isModal) { msg += ` Minimalna ilość znaków to ${s[0]}`; }
			}
			if (s[1] && len > s[1]) {
				const diff = len - s[1];
				msg = `Tekst jest za długi o ${Formatters.PluralForm(diff, chars, true)}`;
				if (isModal) { msg += ` Maksymalna ilość znaków to ${s[1]}`; }
			}
			return msg;
		}
		return '';
	}

	static CompanyName(i, s, form, field) {
		if (!i) { return ''; }
		field.Value = i = i.replace(/( +)/g, ' ');
		const isInvalid = (!/^[0-9A-Za-zÀ-ÿ\\s,._+()*~'#@&sżźćńółęąśŻŹĆĄŚĘŁÓŃ""„"“”: -]+$/g.test(i));
		if (isInvalid) {
			return 'Nazwa firmy musi zaczynać się od litery, cyfry lub cudzysłowu. Nazwa może składać się z liter, cyfr, pojedynczych spacji oraz wybranych znaków specjalnych';
		}

		return field.Value.length < 3 ? 'Nazwa firmy musi zawierać przynajmniej 3 znaki' : ''
	}

	static PersonName(s) {
		const rgx = /^\p{L}+ \p{L}* *\p{L}+[-]{0,1}\p{L}+$/u;
		return (!s.trim().match(rgx)) ? 'Prosimy o podanie imienia i nazwiska' : '';
	}

	static PersonNames(s) {
		const rgx = /^\p{L}+ \p{L}+[- ]{0,1}\p{L}+$/u;
		return (!s.trim().match(rgx)) ? 'Prosimy o podanie imienia i nazwiska' : '';
	}

	static Street(s: string) {
		const rgx = /^\D+ \d/;
		return (!s.match(rgx)) ? 'Prosimy o podanie adresu' : '';
	}

	static PostCode(postCodeFromUser: string) {
		const errorTxt = 'Prosimy o podanie prawidłowego kodu pocztowego';
		const rgxFirstPart = /^\d{2}$/;
		const rgxSecondPart = /^\d{3}$/;

		const firstPart = postCodeFromUser.split('-')[0];
		const secondPart = postCodeFromUser.split('-')[1];

		if (!firstPart || !secondPart) {
			return errorTxt;
		}

		const isCorrectPostCode = rgxFirstPart.test(firstPart) && rgxSecondPart.test(secondPart);

		return isCorrectPostCode ? '' : errorTxt;
	}

	static OptionalSecondName(s: string) {
		const rgx = /^[a-zęóąśłżźćń\s]{3,}$/i;
		return (!s.match(rgx)) ? 'Prosimy o podanie imienia' : '';
	}

	static Date() {}

	static UserName() {}

	static Length(i, s) {
		if (!i) { return ''; }
		i = String(i).length;
		if (i === 0) { return ''; }
		if (s[0] && i < s[0]) { return 'Podana wartość jest za krótka'; }
		if (s[1] && i > s[1]) { return 'Podana wartość jest za długa'; }
		return '';
	}

	static Facebook(i) {
		if (!i) { return ''; }
		if (/^(https?:\/\/)?((w{3}\.)?)facebook.com\/.*/i.test(i)) {
			return '';
		}
		return 'Proszę podać poprawny adres';
	}

	static Instagram(i) {
		if (!i) { return ''; }
		if (/^(https?:\/\/)?((w{3}\.)?)instagram.com\/.*/i.test(i)) {
			return '';
		}
		return 'Proszę podać poprawny adres';
	}

	static async CustomProfileUrlAsync(s) {
		try {
			let rsvp = await fetch(`/myoferteo/konto-json/validate-subdomain.ofer?subdomain=${s}`);
			rsvp = await rsvp.json();
			rsvp = JSON.parse(rsvp);
			return rsvp.result === 'OK' ? '' : rsvp.validationMessage;
		} catch (err) {
			console.warn(err);
		}
		return '';
	}

	static ValidateArray(s, arr) {
		// TODO: Zerżnięte z FormGroup.vue
		for (let v of arr) {
			v = v.split('|');
			const validator = v[0];
			const opts = ((v[1] || '').indexOf(',') > -1) ? v[1].split(',') : v[1];
			const msg = v[2];
			const result = Validators[validator](s, opts);
			if (result) { return msg || result; }
		}
		return '';
	}

	static GoToMailbox(s) {
		if (!s || s.indexOf('@') === -1) {
			return '';
		}
		s = s.split('@')[1];

		const list = {
			'oferteo.pl': 'gmail.com',
			'wp.pl': 'profil.wp.pl',
			'wp.eu': 'profil.wp.pl',
			'poczta.wp.pl': 'profil.wp.pl',
			'xl.wp.pl': 'profil.wp.pl',
			'gmail.com': 'gmail.com',
			'googlemail.com': 'gmail.com',
			'o2.pl': 'poczta.o2.pl',
			'prokonto.pl': 'poczta.o2.pl',
			'go2.pl': 'poczta.o2.pl',
			'tlen.pl': 'poczta.o2.pl',
			'interia.pl': 'poczta.interia.pl',
			'interia.eu': 'poczta.interia.pl',
			'interia.com': 'poczta.interia.pl',
			'onet.pl': 'konto.onet.pl',
			'op.pl': 'konto.onet.pl',
			'buziaczek.pl': 'konto.onet.pl',
			'amorki.pl': 'konto.onet.pl',
			'poczta.onet.eu': 'konto.onet.pl',
			'poczta.onet.pl': 'konto.onet.pl',
			'onet.eu': 'konto.onet.pl',
			'autograf.pl': 'konto.onet.pl',
			'vip.onet.pl': 'konto.onet.pl',
			'spoko.pl': 'konto.onet.pl',
			'onet.com.pl': 'konto.onet.pl',
			'vp.pl': 'konto.onet.pl',
			'adres.pl': 'konto.onet.pl',
			'opoczta.pl': 'konto.onet.pl',
			'outlook.com': 'outlook.live.com',
			'hotmail.com': 'outlook.live.com',
			'gazeta.pl': 'oauth.gazeta.pl',
			'g.pl': 'oauth.gazeta.pl',
			'yahoo.com': 'login.yahoo.com',
			'yahoo.pl': 'login.yahoo.com',
			'yahoo.co.uk': 'login.yahoo.com',
			'icloud.com': 'icloud.com',
			'neostrada.pl': 'webmail.neostrada.pl',
			'mail.ru': 'mail.ru',
			'bk.ru': 'mail.ru',
			'inbox.ru': 'mail.ru',
			'yandex.ru': 'passport.yandex.ru',
			'ukr.net': 'mail.ukr.net',
			'post.pl': 'login.poczta.home.pl',
			'home.pl': 'login.poczta.home.pl',
			'data.pl': 'login.poczta.home.pl',
			'list.pl': 'login.poczta.home.pl',
			'rambler.ru': 'games.rambler.ru',
			'orange.pl': 'poczta.orange.pl',
			'int.pl': 'int.pl',
			'gmx.de': 'gmx.de',
		};
		return list[s] ? (`//${list[s]}`) : '';
	}
}
